import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { db } from '@/integrations/firebase/client';

export interface FeedbackResultDoc {
  id: string;
  personaId?: string;
  personaName?: string;
  rating?: number;
  sentiment?: 'positive' | 'neutral' | 'negative';
  comment?: string;
  createdAt?: number;
  agent?: string;
  
  // Extended fields for personal-feedback agent
  better_moment?: {
    millisecond: number;
    comment: string;
  };
  worst_moment?: {
    millisecond: number;
    comment: string;
  };
  visual?: {
    rating: number;
    comment: string;
  };
  content?: {
    rating: number;
    comment: string;
  };
  script?: {
    rating: number;
    comment: string;
  };
  other?: {
    rating: number;
    comment: string;
  };
  sound_design?: {
    rating: number;
    comment: string;
  };
  pacing?: {
    rating: number;
    comment: string;
  };
  performance?: {
    rating: number;
    comment: string;
  };
  target_focus?: {
    rating: number;
    comment: string;
  };
  insights?: Array<{
    start: number;
    end: number;
    type: string;
    comment: string;
  }>;
  recommendations?: string;
  opinion?: string;
}

export async function listFeedbackResults(feedbackId: string): Promise<FeedbackResultDoc[]> {
  if (!feedbackId) return [];
  
  try {
    const colRef = collection(db, 'feedbacks', feedbackId, 'results');
    // Remove orderBy since it filters out documents without createdAt
    const snap = await getDocs(colRef);
    return snap.docs.map((d) => ({ id: d.id, ...(d.data() as any) })) as FeedbackResultDoc[];
  } catch (error) {
    console.error('Error in listFeedbackResults:', error);
    throw error;
  }
}
